import React from "react";
import "./Tier1_Trusted_Brand.css";
import { WeFocus } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Tier1_Trusted_Brand = () => {

  const { IMG_URL } = useContext(Context);

  const [wefocus, setWeFocus] = useState([]);

  const getWeFocus = async () => {
    const res = await WeFocus();

    if (res?.success) {
      setWeFocus(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getWeFocus();
  }, []);

  return (
    <section
      className="tier1_section"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/aboutus/tier1_brand_banner.png)`,
      }}
    >
      <div className="tier_wrapper">
        <h2 className="tier1_title">
          We focus on <span>Make in India</span> and{" "}
          <span> Premium trusted brands</span>
        </h2>

        <div className="tier1_cards">

          {wefocus?.map((item, index) => (
            <div className="tier1_card" key={index}>
              <p>{item.name}</p>
            </div>
          ))}

        </div>

        <div className="tier1_bottom_text">
          We do not compromise on product quality — because solar is a 25-year
          asset.
        </div>
      </div>
    </section>
  );
};

export default Tier1_Trusted_Brand;